export default __webpack_public_path__ + "static/media/checklist.ee6ca7ef.svg";